export enum LeadStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
  None  = ''
}
